export function CarolChatMockup({ t }) {
  return (
    <div style={{ background: "#0d1117", borderRadius: 12, overflow: "hidden", fontSize: 12 }}>
      <div style={{ background: "#1a3a1a", padding: "9px 12px", display: "flex", alignItems: "center", gap: 8, borderBottom: "1px solid #22c55e22" }}>
        <div style={{ width: 30, height: 30, borderRadius: "50%", background: "#22c55e", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 15 }}>🤖</div>
        <div style={{ flex: 1 }}>
          <div style={{ color: "#fff", fontWeight: 700, fontSize: 12 }}>Carol IA</div>
          <div style={{ color: "#4ade80", fontSize: 10 }}>● Online agora</div>
        </div>
        <div style={{ color: "#555", fontSize: 10, fontWeight: 600 }}>WhatsApp</div>
      </div>
      <div style={{ padding: "10px 12px", display: "flex", flexDirection: "column", gap: 6 }}>
        {t.wa_msgs.map((m, i) => (
          <div key={i} style={{ display: "flex", justifyContent: m.from === "u" ? "flex-end" : "flex-start" }}>
            <div style={{
              maxWidth: "84%",
              background: m.from === "u" ? "#1a3a1a" : "#1e1e1e",
              border: `1px solid ${m.from === "u" ? "#22c55e44" : "#2a2a2a"}`,
              borderRadius: m.from === "u" ? "12px 12px 2px 12px" : "12px 12px 12px 2px",
              padding: "7px 10px", color: m.from === "u" ? "#4ade80" : "#ccc",
              fontSize: 11, lineHeight: 1.5, whiteSpace: "pre-line",
            }}>{m.text}</div>
          </div>
        ))}
      </div>
      <div style={{ margin: "0 12px 12px", background: "#0f1f2f", border: "1px solid #3b82f633", borderRadius: 8, padding: "8px 10px", display: "flex", gap: 8, alignItems: "center" }}>
        <span style={{ fontSize: 16 }}>🖥️</span>
        <div>
          <div style={{ color: "#3b82f6", fontSize: 10, fontWeight: 700, marginBottom: 1 }}>KDS · COZINHA</div>
          <div style={{ color: "#aaa", fontSize: 11 }}>{t.kds_note}</div>
        </div>
      </div>
    </div>
  );
}

export function MenuMockup({ t }) {
  const items = [
    { e: "🍣", n: "Temaki", p: "€9,90", featured: false },
    { e: "🍱", n: "Combo", p: "€22,00", featured: true },
    { e: "🍜", n: "Ramen", p: "€14,50", featured: false },
    { e: "🥗", n: "Poke", p: "€13,00", featured: false },
  ];
  return (
    <div style={{ background: "#0d1117", borderRadius: 12, overflow: "hidden" }}>
      <div style={{ background: "#1a2e1a", padding: "7px 12px", fontSize: 11, color: "#4ade80", fontWeight: 700 }}>{t.menu_banner}</div>
      <div style={{ padding: 10, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 7 }}>
        {items.map((it) => (
          <div key={it.e} style={{
            background: it.featured ? "linear-gradient(135deg,#1a2e1a,#0f1a0f)" : "#111",
            border: `1px solid ${it.featured ? "#22c55e55" : "#1e1e1e"}`,
            borderRadius: 8, padding: "9px 10px", position: "relative",
          }}>
            {it.featured && <div style={{ position: "absolute", top: 5, right: 5, background: "#22c55e", color: "#000", fontSize: 9, fontWeight: 800, borderRadius: 4, padding: "2px 5px" }}>TOP 🔥</div>}
            <div style={{ fontSize: 22, marginBottom: 4 }}>{it.e}</div>
            <div style={{ color: "#ddd", fontSize: 11, fontWeight: 600, marginBottom: 2 }}>{it.n}</div>
            <div style={{ color: "#4ade80", fontSize: 13, fontWeight: 700 }}>{it.p}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function KDSMockup({ t }) {
  const orders = [
    [{ n: "#102", it: "2× Temaki", src: "📱 Mesa 3", tm: "8m" }, { n: "#105", it: "Ramen", src: "🌐 Online", tm: "2m" }],
    [{ n: "#347", it: "Combo Premium", src: "💬 WhatsApp", tm: "3m" }],
    [{ n: "#345", it: "3× Poke", src: "📱 Mesa 1", tm: "✅" }],
  ];
  return (
    <div style={{ background: "#0d1117", borderRadius: 12, padding: 10 }}>
      <div style={{ display: "flex", gap: 6 }}>
        {t.kds_cols.map((col, i) => (
          <div key={i} style={{ flex: 1 }}>
            <div style={{ color: col.c, fontSize: 9, fontWeight: 700, marginBottom: 6, textAlign: "center", paddingBottom: 4, borderBottom: `1px solid ${col.c}33` }}>{col.l}</div>
            {orders[i].map((o) => (
              <div key={o.n} style={{ background: "#111", border: `1px solid ${col.c}33`, borderRadius: 6, padding: "6px 8px", marginBottom: 4 }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 2 }}>
                  <span style={{ color: "#fff", fontSize: 11, fontWeight: 700 }}>{o.n}</span>
                  <span style={{ color: col.c, fontSize: 10, fontWeight: 700 }}>{o.tm}</span>
                </div>
                <div style={{ color: "#aaa", fontSize: 10, marginBottom: 2 }}>{o.it}</div>
                <div style={{ color: "#555", fontSize: 9 }}>{o.src}</div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export function DREMockup({ t }) {
  return (
    <div style={{ background: "#0d1117", borderRadius: 12, padding: 10 }}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 6, marginBottom: 8 }}>
        {t.dre_metrics.map((m) => (
          <div key={m.l} style={{ background: "#111", border: "1px solid #1e1e1e", borderRadius: 8, padding: "8px 10px" }}>
            <div style={{ color: "#666", fontSize: 9, marginBottom: 2 }}>{m.l}</div>
            <div style={{ color: "#fff", fontSize: 16, fontWeight: 800 }}>{m.v}</div>
            <div style={{ color: m.c, fontSize: 10, fontWeight: 600 }}>{m.d}</div>
          </div>
        ))}
      </div>
      <div style={{ background: "#1a1200", border: "1px solid #f59e0b44", borderRadius: 8, padding: "8px 10px", display: "flex", gap: 8 }}>
        <span style={{ fontSize: 15, flexShrink: 0 }}>⚠️</span>
        <span style={{ color: "#fbbf24", fontSize: 11, lineHeight: 1.5 }}>{t.dre_alert}</span>
      </div>
    </div>
  );
}

export function BrainMockup({ t }) {
  return (
    <div style={{ background: "#0d1117", borderRadius: 12, padding: 10 }}>
      <div style={{ background: "#0f0f1f", border: "1px solid #818cf833", borderRadius: 8, padding: "7px 10px", marginBottom: 8, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ color: "#818cf8", fontSize: 12, fontWeight: 700 }}>⚡ Kaiso Brain</span>
        <span style={{ background: "#22c55e", color: "#000", fontSize: 9, borderRadius: 4, padding: "2px 8px", fontWeight: 800 }}>ATIVO</span>
      </div>
      {t.brain_actions.map((a, i) => (
        <div key={i} style={{ background: "#111", border: "1px solid #1e1e1e", borderRadius: 8, padding: "8px 10px", marginBottom: i < t.brain_actions.length - 1 ? 6 : 0, display: "flex", gap: 8 }}>
          <span style={{ color: "#ccc", fontSize: 11, lineHeight: 1.5 }}>{a}</span>
        </div>
      ))}
    </div>
  );
}
